import React from 'react'
import { useVocabulary } from '../context/vocabulary'
import { CurrencyType } from '../models'
import {
  LookupItemPicker,
  LookupItemPickerUserPropsType,
} from './LookupItemPicker'

type CurrencyPickerPropsType = LookupItemPickerUserPropsType

export const CurrencyPicker = (props: CurrencyPickerPropsType) => {
  const { vocabulary } = useVocabulary()

  const allCurrencies: CurrencyType[] = vocabulary.currencies.map((item: CurrencyType) => {
    return {
      code: item.code,
      name: item.code + ' - ' + item.name
    }
  })

  return <LookupItemPicker {...props} lookupItems={allCurrencies} />
}

/* Puvodni kopirovane reseni se lisilo od obecneho LookupItemPickeru:
 1. v input fieldu se zobrazoval KOD
 2. v naseptavaci se zobrazoval: 'KOD - NAME'
<Autocomplete
  options={currencies}
  getOptionLabel={(option) =>
    option.code ?? ''
  }
  // @ts-ignore
  defaultValue={currencyValue}
  getOptionSelected={(option, value) =>
    option.code === value.code
  }
  onChange={(e, value) => {
    setFieldValue(
      `items[${index}].currency`,
      value?.code ?? ''
    )
  }}
  renderOption={(option) => (
    <div>
      {option.code} - {option.name}
    </div>
  )}
  renderInput={(params) => (
    <TextField
      {...params}
      onChange={handleChange}
      //@ts-ignore
      InputProps={{
        ...params.InputProps,
        required: false,
      }}
      required
      onBlur={handleBlur}
    />
  )}
*/
